const CardSchema = {
  title: 'Card (Wildcard)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['stackable', 'itemsPerRow', 'items'],
    },
  ],

  properties: {
    stackable: {
      title: 'Stackable',
      description: 'Forces cards into a single-column stack on mobile layouts',
      type: 'boolean',
      default: true,
    },

    itemsPerRow: {
      title: 'Cards Per Row',
      type: 'number',
      default: 3,
    },

    items: {
      title: 'Cards',
      widget: 'object_list',
      schema: {
        title: 'Card',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'layoutStyle',
              'image',
              'iconName',
              'title',
              'subtitle',
              'link',
              'linkText',
            ],
          },
        ],

        properties: {
          layoutStyle: {
            title: 'Layout Style',
            description: 'Display format for the card',
            type: 'string',
            default: 'classic',
            choices: [
              ['classic', 'Classic (Title Below Image)'],
              ['overlay', 'Overlay (Text on Image)'],
              ['iconText', 'Icon & Text (No Image)'],
            ],
          },

          image: {
            title: 'Image',
            type: 'string',
            widget: 'image',
          },

          iconName: {
            title: 'Icon Name',
            type: 'string',
            default: 'fort awesome',
            description: 'Utilizes Font Awesome library (i.e. "fort awesome")',
          },

          title: {
            title: 'Title',
            type: 'string',
          },

          subtitle: {
            title: 'Subtitle',
            widget: 'textarea',
            type: 'string',
          },

          link: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            selectableTypes: ['Document'],
          },

          linkText: {
            title: 'Link Text',
            type: 'string',
            default: 'Learn more',
          },
        },

        required: ['title'],
      },
    },
  },

  required: ['items'],
};

export default CardSchema;
